import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button as MuiButton,
} from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { forwardRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import assets from "../..";
import { handleAxiosError } from "../../../../common/data/axiosErrorHandler";
import resourceNames from "../../../../common/data/resourceNames";
import {
  MaintenanceDashboardApiFactory,
  VehicleWithDiagnosticRecords,
} from "../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import { useButtonStyles, useTableHeaderStyles, WidgetProps } from "../common";
import { Empty } from "./Empty";
import { Widget } from "./Widget";

export const ActiveDiagnosticErrors = forwardRef(
  ({ className, icon, title, ...rest }: WidgetProps, ref) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<VehicleWithDiagnosticRecords[]>();
    const axios = useAxiosInstance();
    const classes = useTableHeaderStyles();
    const buttonClasses = useButtonStyles();
    const history = useHistory();

    useEffect(() => {
      if (!axios) {
        return;
      }

      setLoading(true);
      MaintenanceDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
        .apiAppMaintenancedashboardActivediagnosticerrorsGet(10)
        .then((result) => {
          setData(result.data);
        })
        .catch((e) => console.error(handleAxiosError(e)))
        .finally(() => setLoading(false));
    }, [axios]);

    return (
      <Widget
        title={title}
        icon={icon}
        className={className}
        ref={ref}
        {...rest}>
        <div className="categories">
          {loading ? (
            <div className="category">
              <CircularProgress size="3rem" />
            </div>
          ) : data && data.length ? (
            <div className="table-wrapper">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      <TableCell>Vehicle</TableCell>
                      <TableCell>DTCs</TableCell>
                      <TableCell>Last DTC</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map((dtc) => (
                      <TableRow key={dtc.vehicleId}>
                        <TableCell>
                          <MuiButton
                            startIcon={<assets.icon />}
                            className={buttonClasses.label}
                            color="primary"
                            onClick={() =>
                              history.push(
                                `/${resourceNames.ASSETS_MAINTENANCE_DASHBOARD}/${dtc.vehicleId}`
                              )
                            }>
                            {dtc.vehicleName!}
                          </MuiButton>
                        </TableCell>
                        <TableCell>{dtc.activeRecordsCount}</TableCell>
                        <TableCell>
                          {format(parseISO(dtc.lastDtcTime!), "MMM do, yyyy")}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <div className="table-wrapper table-wrapper-center">
              <Empty />
            </div>
          )}
        </div>
      </Widget>
    );
  }
);
